export enum MessageVariant {
  Info = "info",
  InfoLight = "infoLight",
  Warning = "warning",
  WarningLight = "warningLight",
  Error = "error",
  ErrorLight = "errorLight",
  Success = "success",
  Neutral = "neutral",
  Draft = "draft",
  WarningDark = "warningDark",
  Deleted = "deleted",
  ErrorPending = "errorPending",
  Purple = "purple",
}
